var character = "Kí tự";
var copied = "Đã sao chép";
var copy = "Sao chép";
var insert = "Chèn";
var loading = "Đang tải";
var orCopyLink = "Hoặc sao chép link";
var submit = "Gửi";
var mbTranslations = {
	"actionPopover.delete": "Xóa",
	"actionPopover.deleteNotification": "Xóa thông báo này",
	"actionPopover.edit": "Chỉnh sửa",
	"actionPopover.inviteShareCommunity": "Mời/Chia sẻ",
	"actionPopover.joinCommunity": "Tham gia cộng đồng",
	"actionPopover.leaveCommunit": "Rời cộng đồng",
	"actionPopover.leaveCommunity": "Rời nhóm",
	"actionPopover.leaveCommunity.accept": "Rời khỏi",
	"actionPopover.leaveCommunity.cancel": "Tắt",
	"actionPopover.leaveCommunity.description": "Bạn có chắc chắn rời khỏi cộng đồng này?",
	"actionPopover.leaveCommunity.title": "Rời cộng đồng",
	"actionPopover.report": "Báo cáo",
	"actionPopover.turnOffNotification": "Tắt thông báo",
	"actionPopover.turnOffNotificationAbout": "Tắt thông báo về {label}",
	"actionPopover.turnOnNotification": "Bật thông báo",
	"adBanner.title": "Quảng cáo",
	"admin.comments": "Bình luận",
	"admin.communities": "Cộng đồng",
	"admin.community": "Cộng đồng",
	"article.shareOn": "Chia sẻ tới",
	"articleAuthor.title.expert": "Tham vấn chuyên môn: ",
	"articleAuthor.title.fact-check": "Thông tin kiểm chứng bởi",
	"articleAuthor.title.medical": "Tham vấn y khoa: ",
	"articleAuthor.title.written-by": "Tác giả",
	"articlePage.articleReviewerBy": "Tham vấn y khoa: {name}",
	"articlePage.readMore": "Đọc tiếp",
	"articlePage.showLess": "Thu gọn",
	"babyGrowth.alert.bmi": "Không có số đo BMI nào để hiển thị cho bé {name} trong phạm vi dữ liệu của WHO từ 0 đến 5 tuổi. Vui lòng sử dụng <a href=\"{bmiUrl}\">công cụ tính BMI</a> cho trẻ trên 5 tuổi",
	"babyGrowth.alert.head": "Không có số đo chu vi vòng đầu để hiển thị cho bé {name} trong phạm vi dữ liệu của WHO từ 0 đến 5 tuổi",
	"babyGrowth.alert.weight": "Không có số đo Cân nặng nào để hiển thị cho bé {name} trong phạm vi dữ liệu của WHO từ 0 đến 10 tuổi",
	"babyGrowth.babyInfo": "Thông tin của bé",
	"babyGrowth.chartTitle": "WHO - Biểu đồ tăng trưởng cho {name}",
	"babyGrowth.chartTitle.noName": "Biểu đồ tăng trưởng của bé",
	"babyGrowth.cm": "cm",
	"babyGrowth.drawer.addMeasurement": "Thêm số đo",
	"babyGrowth.drawer.createBaby": "Tạo hồ sơ mới",
	"babyGrowth.drawer.switchProfile": "Chọn hồ sơ khác",
	"babyGrowth.emptyName": "em bé của bạn",
	"babyGrowth.error.atLeastOneOf": "Phải có ít nhất một trong các trường sau: Cân nặng, Chiều cao, Vòng đầu",
	"babyGrowth.error.birthdayRequired": "Ngày sinh của bé là thông tin bắt buộc",
	"babyGrowth.error.invalidAge": "Các số đo vượt quá độ tuổi của bé.",
	"babyGrowth.error.invalidMeasurementDate": "Ngày đo không hợp lệ.",
	"babyGrowth.error.invalidValue": "Vui lòng nhập một giá trị hợp lệ",
	"babyGrowth.error.measurementDateLowerThanBirthday": "Ngày nhập số liệu trước ngày sinh của bé {name}",
	"babyGrowth.error.outOfRange": "Các số đo vượt quá giới hạn dữ liệu của WHO.",
	"babyGrowth.error.title": "Dữ liệu không hợp lệ",
	"babyGrowth.head": "Vòng đầu",
	"babyGrowth.headCircumference": "Chu vi vòng đầu",
	"babyGrowth.height": "Chiều cao",
	"babyGrowth.input.babyName": "Tên của trẻ",
	"babyGrowth.input.birthday": "Ngày sinh của bé",
	"babyGrowth.input.bmi": "Chỉ số BMI",
	"babyGrowth.input.bodyMass": "Chỉ số BMI",
	"babyGrowth.input.checkSubmit": "Theo dõi sự phát triển của trẻ",
	"babyGrowth.input.measurementDate": "Ngày đo lường",
	"babyGrowth.input.submit": "Theo dõi sự phát triển của bé",
	"babyGrowth.kg": "kg",
	"babyGrowth.kg.m2": "kg/ m2",
	"babyGrowth.monthly": "Theo tháng",
	"babyGrowth.nickname": "Biệt danh",
	"babyGrowth.optional": "(tùy chọn)",
	"babyGrowth.pageTitle": "Biểu đồ phát triển của bé",
	"babyGrowth.percentiles": "Bách phân vị",
	"babyGrowth.placeholder.babyName": "Nhập tên của em bé",
	"babyGrowth.popup.heading": "Hồ sơ của bé",
	"babyGrowth.reCalculate": "Tính toán lại",
	"babyGrowth.record": "Dữ liệu",
	"babyGrowth.save": "Theo dõi quá trình phát triển của trẻ",
	"babyGrowth.save.loggedIn": "Xem biểu đồ tăng trưởng của bé",
	"babyGrowth.weekly": "Theo tuần",
	"babyGrowth.weight": "Cân nặng",
	"babyGrowth.xLabel": "Tuổi ({recurrence})",
	"babyGrowth.yearly": "Theo năm",
	"babyPoop.findOut": "Tìm hiểu thêm",
	"babyPoopTool.name": "Công cụ Phân tích hình ảnh phân trẻ em",
	"babyVaccine.banner.readmore": "Xem thêm",
	"babyVaccine.detail.benifit": "Lợi ích",
	"babyVaccine.detail.contraindication": "Chống chỉ định",
	"babyVaccine.detail.definition": "Định nghĩa",
	"babyVaccine.detail.relatedArticles": "Bài viết liên quan",
	"babyVaccine.immunization.vaccineName": "Tên vắc-xin",
	"babyVaccine.immunization.warning": "Thống kê tiêm chủng dễ đọc và thân thiện với ba mẹ vì nó tương tự như bảng hồ sơ tiêm chủng của con bạn",
	"babyVaccine.popup.button": "Tạo hồ sơ mới",
	"babyVaccine.popup.button.submit": "Lưu",
	"babyVaccine.popup.checkbox.suggestedDate": "Chọn lại ngày tiêm hoặc giữ ngày được đề xuất như bên dưới:",
	"babyVaccine.popup.confirm.close": "Đổi ngày",
	"babyVaccine.popup.confirm.description": "Bé đã tiêm vắc-xin này vào {date}",
	"babyVaccine.popup.confirm.ok": "Xác nhận",
	"babyVaccine.popup.confirm.title": "Ngày tiêm",
	"babyVaccine.popup.input.suggestedDate": "Tôi không nhớ/Chọn như ngày đề xuất",
	"babyVaccine.popup.label.doses": "Mũi",
	"babyVaccine.popup.tab.benefits": "Lợi ích",
	"babyVaccine.popup.tab.contraindication": "Chống chỉ định",
	"babyVaccine.popup.tab.detail": "Thông tin chi tiết",
	"babyVaccine.popup.tab.schedule": "Theo dõi",
	"babyVaccine.popup.title": "Thông tin vắc-xin",
	"babyVaccine.status.all": "Tất cả",
	"babyVaccine.status.missed": "Bỏ lỡ",
	"babyVaccine.status.next": "Tiếp theo",
	"babyVaccine.status.upcoming": "Sắp tới",
	"babyVaccine.status.vaccinated": "Đã tiêm",
	"babyVaccine.timeline.antigen": "Kháng nguyên:",
	"babyVaccine.timeline.atBirth": "Mới sinh",
	"babyVaccine.timeline.total": "Tổng: {number} mũi",
	"babyVaccine.timeline.totalNext": "Sẽ tiêm {number} mũi",
	"babyVaccine.timeline.totalPast": "Đã tiêm {number} mũi",
	"babyVaccine.vaccineCard.injected": "Đã tiêm",
	"babyVaccine.vaccineCard.markAsInjected": "Đánh dấu đã tiêm",
	"babyVaccine.vaccineInfo.dose": "Mũi: {ordinal}/{total}",
	"babyVaccine.vaccineInfo.injectedDate": "Ngày tiêm: {date}",
	"babyVaccine.vaccineInfo.mandatory": "Bắt buộc",
	"babyVaccine.vaccineInfo.optional": "Tùy chọn",
	"babyVaccine.vaccineInfo.suggested": "Ngày đề xuất: {date}",
	"babyVaccineTool.heading": "Lịch theo dõi tiêm chủng cho bé",
	"bmi.ageInput": "Bạn bao nhiêu tuổi?",
	"bmi.ageInput.desc": "(năm)",
	"bmi.ageInput.error": "Vui lòng nhập số tuổi chính xác",
	"bmi.heading": "Tính chỉ số BMI - Chỉ số khối cơ thể",
	"bmi.heightInput": "Bạn cao bao nhiêu?",
	"bmi.heightInput.desc": "(cm)",
	"bmi.heightInput.error": "Vui lòng nhập chiều cao chính xác",
	"bmi.objective": "Mục tiêu của bạn",
	"bmi.objective.gainWeight": "Phát triển cơ bắp",
	"bmi.objective.loseWeight": "Giảm mỡ thừa",
	"bmi.objective.maintainWeight": "Duy trì cân nặng",
	"bmi.result.healthy": "Khỏe mạnh",
	"bmi.result.overweight": "Thừa cân",
	"bmi.result.underweight": "Thiếu cân",
	"bmi.selectGender": "Giới tính của bạn",
	"bmi.submit": "Tính ngay",
	"bmi.weightInput": "Cân nặng của bạn",
	"bmi.weightInput.desc": "(kg)",
	"bmi.weightInput.error": "Vui lòng nhập số cân nặng chính xác",
	"bmr.heading": "Tính chỉ số BMR",
	"booking.searchBar.allLocations": "Tất cả vị trí",
	"booking.searchBar.allSpecialties": "Tất cả chuyên khoa",
	"booking.searchBar.currentLocation": "Vị trí hiện tại",
	"booking.searchBar.grantLocation": "Vui lòng cho phép cấp quyền để tìm kiếm theo vị trí hiện tại",
	"booking.searchBar.locationPlaceholder": "Nhập tỉnh thành",
	"booking.searchBar.noResults": "Không có kết quả",
	"booking.searchBar.placeholder.doctor": "Tìm kiếm với tên Bác sĩ",
	"booking.searchBar.placeholder.hospital": "Tìm kiếm với tên Bệnh viện",
	"booking.searchBar.placeholder.service": "Tìm kiếm với tên Dịch vụ",
	"booking.searchBar.placeholder.specialty": "Tìm kiếm bằng Chuyên Khoa",
	"booking.searchBar.popularKey": "Từ khóa Phổ Biến",
	"booking.searchBar.searchButton": "Tìm kiếm",
	"booking.searchBar.searchInput.placeholder": "Tìm kiếm bằng Chuyên khoa hoặc Phòng khám...",
	"booking.searchBar.useCurrentLocation": "Ví trí hiện tại",
	"booking.searchBar.viewAll": "Xem tất cả",
	"booking.searchPopup.doctors": "Bác sĩ",
	"booking.searchPopup.hospitals": "Bệnh viện và Phòng khám",
	"booking.searchPopup.searchIn.doctors": "Tim kiếm \"{name}\" trong Bác sĩ",
	"booking.searchPopup.searchIn.hospitals": "Tim kiếm \"{name}\" trong Bệnh viện",
	"booking.searchPopup.searchIn.services": "Tìm kiếm \"{name}\" trong Dịch vụ",
	"booking.searchPopup.searchIn.specialties": "Tìm kiếm \"{name}\" trong Chuyên khoa",
	"booking.searchPopup.seeAll": "Xem tất cả",
	"booking.searchPopup.seeLessSpecialties": "Thu gọn tất cả chuyên khoa",
	"booking.searchPopup.seeMoreSpecialties": "Xem thêm Chuyên Khoa",
	"booking.searchPopup.services": "Dịch vụ",
	"booking.searchPopup.specialties": "Chuyên khoa",
	"booking.searchResult.description": "{search_type} trong {search_location}",
	"bottomBar.share": "Chia Sẻ",
	"cardAuthor.admin": "Admin",
	"cardAuthor.ambassador": "Thành viên danh dự",
	"cardAuthor.expert": "Chuyên gia",
	"cardAuthor.guide": "Guide",
	"cardAuthor.influencer": "Người truyền cảm hứng",
	"cardAuthor.localAdmin": "Local Admin",
	"cardAuthor.moderator": "Kiểm duyệt viên",
	"cardAuthor.sponsor": "Nhà tài trợ",
	"cardPost.anonymous": "Người dùng ẩn danh",
	"cardPost.option.anonymous": "Ẩn danh",
	"cardPost.public": "Công khai",
	"cardReactions.comment": "Bình luận",
	"cardReactions.like": "Thích",
	"cardReactions.repliesCount": "{count} trả lời",
	"cardReactions.reply": "Trả lời",
	"cardReactions.save": "Lưu",
	"cardReactions.unSave": "Bỏ Lưu",
	"cardReply.disclaimer": "<strong>Miễn trừ trách nhiệm:</strong> Mọi thông tin trên đều mang tính tham khảo, không thay thế cho việc chẩn đoán hoặc điều trị y khoa.",
	"cardReply.endorse": "Chứng nhận",
	"cardReply.opposePopup.content": "Xin vui lòng cung cấp lý do cho việc phản đối câu trả lời này.",
	"cardReply.opposePopup.submit": "Gửi đi",
	"cardReply.pppose": "Bác bỏ",
	"cardReply.recommentCategories.heading": "Chuyên mục liên quan",
	"cardReply.source": "Tham khảo thêm ",
	"cardReply.verifyBy": "Tham vấn y khoa bởi {name}",
	"careBooking.bookAnAppointment": "Đặt lịch ngay",
	"categoryPage.info.reviewed": "Tham vấn y khoa:",
	"categoryPage.onDate": "ngày {date}",
	character: character,
	"chatbot.with.me": "Trò chuyện với tôi",
	"childCard.age.months": "{month} tháng tuổi",
	"childCard.age.oneMonth": "1 tháng tuổi",
	"childCard.age.oneWeek": "1 tuần",
	"childCard.age.oneYear": "1 năm",
	"childCard.age.oneYearMonth": "1 năm {month} tháng",
	"childCard.age.oneYearOneMonth": "1 năm 1 tháng",
	"childCard.age.week": "{weeks} tuần",
	"childCard.age.yearMonth": "{year} năm {month} tháng",
	"childCard.age.yearNoMonth": "{year} năm",
	"childCard.age.yearOneMonth": "{year} năm 1 tháng",
	"childCard.boy": "Bé trai",
	"childCard.girl": "Bé gái",
	"childCard.menu.add": "Tạo hồ sơ mới",
	"childCard.menu.edit": "Cập nhật hồ sơ của {name}",
	"childCard.menu.remove": "Xóa hồ sơ của {name}",
	"childCard.menu.switch": "Chọn hồ sơ khác",
	"childCard.noName": "Tên của trẻ",
	"choicePopover.ambassadorPosts": "Bài viết Thành viên danh dự",
	"choicePopover.expertPosts": "Bài viết Chuyên gia",
	"choicePopover.lastestPost": "Bài viết mới nhất",
	"choicePopover.latest": "Cập nhật nhất",
	"choicePopover.newest": "Mới nhất",
	"choicePopover.oldest": "Cũ nhất",
	"choicePopover.popular": "Phổ biến",
	"choicePopover.popularPost": "Bài viết nhiều người xem",
	"choicePopover.sort": "Sắp xếp theo",
	"choose.community": "Tự chọn cộng đồng",
	"choose.other.community": "Chọn cộng đồng khác",
	"chooseBaby.button": "Xem biểu đồ phát triển của trẻ",
	"chooseBaby.new": "Hoặc tạo hồ sơ mới",
	"chooseBaby.placeholder": "Vui lòng nhập tên trẻ",
	"chooseBaby.title": "Chọn 1 hồ sơ",
	"comment.count": "{count} bình luận",
	"comment.now": "Bình luận ngay",
	"comment.seeMoreComments": "Xem thêm {count} bình luận",
	"comment.seeMoreReplies": "Xem thêm {count} phản hồi",
	"commentPopup.warning.newPost": "Câu hỏi của bạn sẽ được hiển thị công khai",
	"common.playing": "Đang xem ...",
	"common.profileNavigator.newsletterSubscription": "Đăng ký bản tin sức khỏe",
	"common.sponsoredBy": "Tài trợ bởi",
	"common.totalView": "{number} lượt xem",
	"community.choose": "Chọn một cộng đồng",
	"community.notification.joined": "Bạn đã tham gia cộng đồng {name}",
	"community.notification.left": "Bạn đã rời khỏi cộng đồng {name}",
	copied: copied,
	copy: copy,
	"createPost.askDoctor": "Hỏi bác sĩ",
	"createPost.askDoctor.description": "Nhận tư vấn từ bác sĩ",
	"createPost.askDoctorChoice.no": "Không",
	"createPost.askDoctorChoice.yes": "Có",
	"createPost.communityAndTopic": "Cộng đồng & Chủ đề",
	"createPost.message.askDoctorRequire": "Bạn có muốn đặt câu hỏi này cho bác sĩ không?",
	"createPost.message.askDoctorRequireMess": "Vui lòng chọn một tùy chọn",
	"createPost.message.lengthDescription": "Mô tả phải có ít nhất 10 từ | Hiện tại: {currentLength} từ",
	"createPost.message.lengthTitle": "Tiêu đề phải có ít nhất 5 từ",
	"createPost.message.lengthTitle.characters": "Tiêu đề phải có ít nhất 5 kí tự.",
	"createPost.message.photoMaxium": "Tối đa 10 hình ảnh khi tải lên bài viết",
	"createPost.message.photoSize": "Chỉ cho phép tải lên hình ảnh có kích thước <= 10 MB",
	"createPost.message.requiredDescription": "Bắt buộc phải có mô tả",
	"createPost.message.requiredTitle": "Bắt buộc phải có tiêu đề",
	"createPost.message.suggestLoading": "Chúng tôi đang gợi ý cộng đồng phù hợp với bài đăng của bạn",
	"createPost.message.suggestResult": "Bạn đã có thể đăng bài ngay! Chúng tôi sẽ tiếp tục tìm cộng đồng phù hợp ngay sau đó",
	"createPost.now": "Đăng bài ngay",
	"createPost.photos": "Ảnh",
	"createPost.popup.description": "Mô tả",
	"createPost.popup.guideSelectMonthTopics": "Chọn các chủ đề vể tháng sinh của bé",
	"createPost.popup.guideSelectTopics": "Chọn các chủ đề, nơi đăng bài viết của bạn",
	"createPost.popup.primary": "Chạm để chọn/bỏ chọn chủ đề",
	"createPost.popup.selectMonthTopicBtn": "Chọn",
	"createPost.popup.specialCharErr": "Tiêu đề bạn nhập không hợp lệ. Tiêu đề phải chứa các chữ cái.",
	"createPost.popup.submit": "Đăng",
	"createPost.popup.success": "Đã tạo bài mới",
	"createPost.popup.warning": "Chọn một cộng đồng để xem các chủ đề bạn đang theo dõi",
	"createPost.popup.warningImage": "Cho phép nhiều nhất 20 tấm hình, bạn hãy xoá bớt cho đạt yêu cầu",
	"createPost.popup.wordCount": "{count}/{max} từ",
	"createPost.post.askDoctor.description": "Mô tả triệu chứng",
	"createPost.post.askDoctor.title": "Tên triệu chứng",
	"createPost.post.description": "Mô tả bài đăng",
	"createPost.post.title": "Tiêu đề bài đăng",
	"createPost.postAnonymous": "Đăng bài ẩn danh",
	"createPost.title": "Tiêu đề",
	"createPost.urlText": "Nội dung",
	"createPost.video": "Video",
	"createPost.videoOrLink": "Video hoặc liên kết",
	"dueDatePage.IUI": "Thụ tinh nhân tạo (IUI)",
	"dueDatePage.calculationMethod": "Phương pháp tính toán",
	"dueDatePage.conceptionDate": "Ngày thụ thai",
	"dueDatePage.date_of_IUI_procedure": "Ngày bơm tinh trùng",
	"dueDatePage.date_of_ultrasound": "Ngày siêu âm",
	"dueDatePage.daysText": "{number} ngày",
	"dueDatePage.ivf": "Thụ tinh trong ống nghiệm IVF",
	"dueDatePage.ivf.transferDate": "Ngày chuyển phôi",
	"dueDatePage.ivf.transferDateRadio": "{number} - Ngày chuyển phôi",
	"dueDatePage.lastPeriod": "Kỳ kinh nguyệt cuối cùng",
	"dueDatePage.lastPeriod.calculate": "Tính ngay",
	"dueDatePage.lastPeriod.lastPeriodLabel": "Ngày đầu tiên của chu kỳ gần nhất",
	"dueDatePage.lastPeriod.periodLengthLabel": "Độ dài chu kỳ kinh nguyệt",
	"dueDatePage.ultrasound": "Siêu âm",
	"dueDatePage.ultrasound.tooltip": "Chỉ số Đường kính trung bình túi thai (MSD) ít chính xác hơn Chiều dài đầu mông (CRL) trong tính toán chỉ số thai kỳ. Nó chỉ được áp dụng cho giai đoạn mang thai rất sớm, từ 4 - 6 tuần.",
	"dueDatePage.validation.crl": "Giá trị MSD không hợp lệ. Vui lòng nhập chỉ số CRL để tiếp tục.",
	"dueDatePage.validation.one_is_required": "Ít nhất một trường thông tin cần điền",
	"dueDatePage.validation.record_not_valid": "Thông tin nhập chưa hợp lệ!",
	"editor.addSocialLink.addLink": "Thêm",
	"editor.addSocialLink.warningDomain": "Chỉ cho phép các nguồn từ Youtube, Facebook, và Tiktok",
	"expert.content.description": "Hồ sơ chuyên gia",
	"expert.content.experiences": "Kinh nghiệm làm việc",
	"footer.signUp": "Đăng ký ngay",
	"gender.boy": "Bé trai",
	"gender.female": "Nữ",
	"gender.girl": "Bé gái",
	"gender.male": "Nam",
	"healthToolPNModal.back": "Quay lại",
	"healthToolPNModal.findMore.chooseFav": "Các chủ đề yêu thích khác của bạn",
	"healthToolPNModal.finish": "Hoàn tất",
	"healthToolPNModal.heading": "Bạn có muốn nhận bản tin miễn phí?",
	"healthToolPNModal.mainForm.requireName": "Xin nhập tên của bạn",
	"healthToolPNModal.mainForm.tailorTopicsHeading": "Những chủ đề được lựa chọn dựa trên kết quả của bạn",
	"healthToolPNModal.next": "Tiếp tục",
	"healthToolPNModal.register": "Đăng ký",
	"healthToolPNModal.yourPre": "Chủ đề bạn yêu thích",
	"healthTools.dueDateCalculator": "Công cụ tính ngày dự sinh",
	"healthTools.ovulationCalculator": "Công cụ tính ngày rụng trứng",
	"healthtool.placeholder.age": "Số tuổi",
	"home.calcWithApp": "Tính ngay với Hello Bacsi app",
	"home.menu.category.view": "Xem {category}",
	"home.navigator.app": "App",
	"home.navigator.downloadApp": "Tải App",
	"home.navigator.menu.care.homeButton": "Tất cả chuyên khoa ›",
	"home.navigator.menu.care.noDatas.cta": "Khám phá ngay",
	"home.navigator.menu.care.noDatas.description": "Giúp bạn đơn giản hóa việc tìm kiếm bác sĩ và dịch vụ y tế phù hợp với nhu cầu sức khoẻ, dù ở bất kỳ đâu.",
	"home.navigator.menu.care.noDatas.title": "Đặt lịch hẹn với bác sĩ dễ dàng",
	"home.navigator.menu.category.noDatas.cta": "Khám phá ngay",
	"home.navigator.menu.category.noDatas.description": "MarryBaby là cộng đồng Mẹ và Bé, chuyên cung cấp các thông tin và kinh nghiệm hữu ích trong việc Thụ thai, Mang thai, Nuôi dạy con và Sức khỏe gia đình. Chúng tôi cam kết đem đến những bài viết về chăm sóc sức khỏe mẹ, bé và gia đình hữu ích, dễ đọc và đáng tin cậy.",
	"home.navigator.menu.category.noDatas.title": "Chào mừng đến với Marry Baby",
	"home.navigator.menu.healthTools.noDatas.cta": "Khám phá thêm",
	"home.navigator.menu.healthTools.noDatas.description": "Các công cụ đánh giá sức khỏe này sẽ giúp bạn đánh giá  sức khỏe tổng quát và các chức năng sức khỏe quan trọng khác.",
	"home.navigator.menu.healthTools.noDatas.title": "Công cụ sức khỏe",
	"home.navigator.menu.lastestVideos": "Videos",
	"home.navigator.menu.podcasts": "Podcasts",
	"home.navigator.menu.shorts": "Shorts",
	"home.navigator.menu.spotlightEcom": "Danh mục",
	"home.navigator.menu.spotlightHospitals": "Bệnh viện nổi bật",
	"home.navigator.menu.spotlightTools": "Công cụ nổi bật",
	"home.navigator.menu.spotlights": "Tâm điểm",
	"home.navigator.menu.spotlights.seeAll": "Các chủ đề Tâm điểm",
	"home.navigator.menu.together.noPosts.cta": "Tham gia Cộng đồng",
	"home.navigator.menu.together.noPosts.description": "Cộng đồng là không gian an toàn, nơi bạn có thể kết nối với các thành viên khác, chia sẻ về các chủ đề bạn quan tâm và nhận tham vấn đáng tin cậy từ các Chuyên gia y tế về các vấn đề sức khỏe quan trọng nhất.",
	"home.navigator.menu.together.noPosts.title": "Chào mừng đến với Cộng đồng",
	"home.navigator.menu.trendingPosts": "Bài đăng nổi bật",
	"home.navigator.menu.trendingPosts.seeMore": "Xem thêm",
	"home.navigator.menu.videos": "Videos",
	"home.navigator.menuItem.allCategories": "Xem tất cả chuyên mục",
	"home.navigator.menuItem.allCommunities": "Xem tất cả cộng đồng",
	"home.navigator.menuItem.allCommunitiesheadingTitle": "Tìm cộng đồng của bạn",
	"home.navigator.menuItem.allHealthTools": "Xem tất cả công cụ",
	"home.navigator.menuItem.allSpecialties": "Trang chủ đặt lịch",
	"home.navigator.menuItem.allSpotlight": "Các chủ đề Tâm điểm",
	"home.navigator.menuItem.allVideos": "Xem tất cả video",
	"home.navigator.menuItem.discover": "Chuyên mục",
	"home.navigator.menuItem.healthCategories": "Chuyên mục sức khỏe",
	"home.navigator.menuItem.healthTools": "Kiểm tra sức khỏe",
	"home.navigator.menuItem.healthToolsList": "Công cụ sức khỏe",
	"home.navigator.menuItem.helloCare": "Đặt lịch với bác sĩ",
	"home.navigator.menuItem.helloEcom": "Cửa hàng",
	"home.navigator.menuItem.helloTogether": "Cộng đồng",
	"home.navigator.menuItem.language": "Ngôn ngữ ",
	"home.navigator.menuItem.new": "mới",
	"home.navigator.menuItem.specialties": "Các chuyên khoa",
	"home.navigator.menuItem.spotlights": "Tâm điểm",
	"home.navigator.menuItem.video": "Video",
	"home.navigator.menuItem.videoCategories": "Chuyên mục video",
	"home.search": "Tìm kiếm {site}",
	"home.seeAll": "Xem tất cả",
	"home.seeAllCategories": "Xem tất cả chủ đề",
	"home.seeExpert": "Xem đầy đủ hồ sơ bác sĩ",
	"home.seeHospital": "Xem đầy đủ thông tin bệnh viện",
	"home.seeMore": "Xem thêm",
	"home.seeMoreExperts": "Xem thêm Chuyên gia",
	"hospital.content.description": "Thông tin bệnh viện",
	"inputComment.replyTo": "Trả lời {name}",
	insert: insert,
	"label.latestPost": "Bài viết mới nhất",
	"label.pinnedPost": "Bài đăng được ghim",
	"lead.empty.cancel": "Hủy",
	"lead.empty.submitAgain": "Gửi lại",
	"lead.empty.title": "Oops, có vẻ như thông tin của bạn đang trống. Bạn có muốn gửi lại thông tin không?",
	"leadgen.message.error.name_required": "Vui lòng nhập tên",
	"leadgen.message.error.phone_invalid": "Vui lòng nhập số điện thoại hợp lệ",
	loading: loading,
	"login.booking": "Đặt lịch với bác sĩ",
	"logout.popup.ask.mb": "Đăng xuất khỏi Marry Baby?",
	"logout.popup.ask1": "Đăng xuất khỏi Hello Bacsi?",
	"logout.popup.ask2": "Bạn có chắc chắn muốn đăng xuất?",
	"logout.popup.button.cancel": "Hủy",
	"logout.popup.button.logout": "Đăng xuất",
	"menu.care.searchBySpecialties": "Tìm kiếm bằng chuyên khoa",
	"morePopover.report": "Báo cáo",
	"morePopover.report.description": "Vui lòng giải thích vấn đề với bài đăng này.",
	"morePopover.report.falseNews": "Tin tức sai lệch",
	"morePopover.report.offensive": "Phản cảm",
	"morePopover.report.other": "Khác",
	"morePopover.report.prohibited": "Nội dung bị cấm",
	"morePopover.report.scam": "Sai sự thật hoặc lừa gạt",
	"morePopover.report.sex": "Khiêu dâm",
	"morePopover.report.spam": "Spam",
	"morePopover.report.title": "Báo cáo bài đăng này",
	"morePopover.report.violence": "Bạo lực",
	"morePopover.reportSubmit.description": "Chúng tôi sẽ không tiết lộ người báo cáo. Vui lòng kiểm tra những chi tiết dưới đây:",
	"morePopover.reportSubmit.title": "Gửi báo cáo",
	"morePopover.savePost": "Lưu bài",
	"morePopover.share": "Chia sẻ",
	"morePopover.shareOn": "Chia sẻ trên",
	"morePopover.turnOffNotifications": "Tắt thông báo",
	"morePopover.turnOnNotifications": "Bật thông báo",
	"morePopover.unsavePost": "Xóa lưu bài",
	"navigation.loginJoin": "Đăng nhập",
	"navigation.search.input.placeholder": "Tìm kiếm",
	"navigation.signUp": "Đăng ký",
	"newsletter.error.minCotennt": "Vui lòng chọn ít nhất 1 chủ đề để tiếp tục bước này",
	"newsletter.error.minTitle": "Đã chọn 1 chủ đề ",
	"newsletter.topic.title": "Bạn quan tâm đến những chủ đề sức khỏe nào?",
	"newsletter.welcome.description": "Tên bạn là gì?",
	"notification.comment.blocked.message": "Bình luận này chứa từ ngữ bị chặn và sẽ không được phép đăng",
	"notification.comment.blocked.title": "Bình luận bị chặn",
	"notification.comment.premod": "Bình luận sẽ được kiểm duyệt trước khi đăng tải.",
	"notification.comment.rejected": "Bình luận của bạn chứa từ vi phạm kiểm duyệt.",
	"notification.comment.reportFailed": "Thất bại!",
	"notification.comment.reportSuccess": "Bạn đã báo cáo bình luận này thành công.",
	"notification.comment.somethingWrong": "Có lỗi xảy ra!",
	"notification.comment.suspect.message": "Bình luận này chứa từ ngữ bị khuyến cáo và đang chờ được kiểm duyệt",
	"notification.comment.suspect.title": "Bình luận chờ kiểm duyệt",
	"notification.comment.systemWithheld": "Bình luận sẽ được kiểm duyệt trước khi đăng tải.",
	"notification.failure": "Có lỗi xảy ra. Vui lòng thử lại",
	"notification.limitUrlDomain": "Không thể post link ngoài Hello Health Group.",
	"notification.post.blocked.message": "Bài viết này chứa từ ngữ bị chặn và sẽ không được phép đăng",
	"notification.post.blocked.title": "Bài viết bị chặn",
	"notification.post.delete": "Đã xóa bài viết",
	"notification.post.suspect.message": "Bài viết này chứa từ ngữ bị khuyến cáo và đang chờ được kiểm duyệt",
	"notification.post.suspect.title": "Bài viết chờ kiểm duyệt",
	"notification.success": "Thành công",
	"notification.suspend.message": "Tài khoản của bạn đã bị tạm ngưng do vi phạm điều khoản dịch vụ của chúng tôi",
	"notification.urlWrongFormat": "Sai định dạng URL",
	"onboarding.button.continue": "Tiếp tục",
	"onboarding.button.skip": "Bỏ qua",
	"onboarding.errorMessage.invalidEmail": "Email không hợp lệ",
	"onboarding.errorMessage.minLength": "Vui lòng điền ít nhất {length} ký tự",
	"onboarding.errorMessage.passNotMatch": "Mật khẩu phải trùng khớp",
	"onboarding.errorMessage.passWithPattern": "Mật khẩu phải bao gồm ký tự viết hoa và viết thường",
	"onboarding.errorMessage.requiredConfirmPassword": "Vui lòng xác nhận mật khẩu của bạn",
	"onboarding.errorMessage.requiredEmail": "Vui lòng nhập email của bạn",
	"onboarding.errorMessage.requiredName": "Vui lòng nhập tên của bạn",
	"onboarding.errorMessage.requiredPassword": "Vui lòng nhập mật khẩu của bạn",
	"onboarding.formEmail.description": "Bắt đầu với email của bạn để tiếp tục tham gia cộng đồng {site}",
	"onboarding.formEmail.genderFemale": "Nữ",
	"onboarding.formEmail.genderMale": "Nam",
	"onboarding.formEmail.heading": "Chúng tôi hy vọng được hiểu thêm về bạn",
	"onboarding.formEmail.yourBirthday": "Ngày sinh của bạn",
	"onboarding.formEmail.yourEmail": "Email của bạn",
	"onboarding.formEmail.yourName": "Tên của bạn",
	"onboarding.label.fullName": "Full name",
	"onboarding.otpForm.description": "Chúng tôi đã gửi mã xác nhận (OTP) đến số điện thoại của bạn {phone}",
	"onboarding.otpForm.descriptionEmail": "Chúng tôi đã gửi Mật khẩu tạm thời (OTP) đến email {email} của bạn",
	"onboarding.otpForm.error": "OTP không hợp lệ",
	"onboarding.otpForm.heading": "Nhập mã OTP",
	"onboarding.otpForm.notReceiveOTP": "Bạn vẫn chưa nhận được mã OTP?",
	"onboarding.otpForm.resendCode": "Gửi lại mã",
	"onboarding.otpForm.resendCodeWithSeconds": "Gửi lại mã sau {seconds} giây",
	"onboarding.otpWhatsapps.description": "Chúng tôi đã gửi Mật khẩu Một lần (OTP) đến số điện thoại WhatsApp của bạn {phone}",
	"onboarding.otpWhatsapps.heading": "Xác minh với WhatsApp",
	"onboarding.similac.address.error": "Vui lòng điền địa chỉ",
	"onboarding.similac.input.address": "Đia chỉ của bạn",
	"onboarding.similac.input.city": "Vui lòng chọn thành phố/ tỉnh",
	"onboarding.similac.input.district": "Vui lòng chọn quận/ huyện",
	"onboarding.similac.input.no": "Vui lòng nhập tên đường, toà nhà, số nhà",
	"onboarding.similac.input.phone": "Số điện thoại của bạn",
	"onboarding.similac.input.ward": "Vui lòng chọn phường/ xã",
	"onboarding.updatePassword.confirmPassword": "Xác nhận mật khẩu",
	"onboarding.updatePassword.description": "Hãy đảm bảo mật khẩu có từ 8 ký tự trở lên.",
	"onboarding.updatePassword.heading": "Sắp hoàn thành rồi! Bạn sẽ cần tạo mật khẩu.",
	"onboarding.updatePassword.password": "Mật khẩu",
	"onboarding.updatePasswordResult.description": "Bây giờ bạn có thể đăng nhập vào tài khoản MarryBaby với mật khẩu mới",
	"onboarding.updatePasswordResult.heading": "Thiết lập mật khẩu thành công",
	"onboarding.updatePhone.description": "Chúng tôi sẽ gửi mã xác nhận (OTP) đến số điện thoại của bạn",
	"onboarding.updatePhone.error": "Số điện thoại không hợp lệ",
	"onboarding.updatePhone.heading": "Số điện thoại của bạn",
	"onboarding.updateWhatsapp.description": "Whatsapp sẽ cần xác minh số điện thoại của bạn.",
	"onboarding.updateWhatsapp.submitLabel": "Tiếp tục với WhatsApp",
	"onboarding.welcomeScreen.content": "Một cộng đồng cởi mở và là nơi bạn có thể chia sẻ, kết nối, và hỗ trợ giữa các thành viên nhằm giúp bạn có cuộc sống khỏe mạnh và hạnh phúc hơn.",
	"onboarding.welcomeScreen.heading": "Chào mừng bạn đến với Cộng đồng MarryBaby",
	orCopyLink: orCopyLink,
	"ovulationPage.avoidPregnancy": "Tránh thai",
	"ovulationPage.conceive": "Cơ hội thụ thai",
	"ovulationPage.cycleLength": "Độ dài chu kỳ kinh nguyệt",
	"ovulationPage.dayUnit": "ngày",
	"ovulationPage.objectives": "Mục đích",
	"ovulationPage.periodDuration": "Số ngày hành kinh",
	"ovulationPage.trackPeriod": "Theo dõi chu kỳ kinh",
	"placeholder.enterTitleHere": "Nhập tiêu đề ở đây",
	"placeholder.enterUrlHere": "Nhập URL ở đây",
	"placeholder.enterUrlTextHere": "Nhập URL text ở đây",
	"placeholder.newCmt": "Viết bình luận",
	"placeholder.newPost": "Bắt đầu bài đăng mới",
	"pnBanner.both": "Cả hai",
	"pnBanner.both.desc": "Chào mừng đến với hành trình nuôi dạy con! Hãy chọn công cụ chăm sóc sức khỏe đúng với nhu cầu của bé và bạn nhé.",
	"pnBanner.both.heading": "Trải nghiệm các công cụ hỗ trợ chăm sóc trẻ",
	"pnBanner.caclNow": "Tính ngay",
	"pnBanner.checkNow": "Kiểm tra ngay!",
	"pnBanner.dueDateTool.desc": "Lên kế hoạch  cho ngày đón bé chào đời một cách thoải mái và không cần lo âu!",
	"pnBanner.dueDateTool.heading": "Khám phá Công cụ Tính ngày dự sinh",
	"pnBanner.hpv.desc": "Phản hồi của bạn sẽ giúp chúng tôi gợi ý các nội dung phù hợp nhất với gia đình bạn.",
	"pnBanner.hpv.heading": "Bảo vệ bé gái trước virus HPV!",
	"pnBanner.parenting.desc": "Phản hồi của bạn giúp chúng tôi phác thảo các nội dung gợi ý phù hợp nhất với nhu cầu của gia đình bạn.",
	"pnBanner.parenting.heading": "Độ tuổi của con bạn nằm trong khoảng nào?",
	"pnBanner.pn.btnLabel": "Bản tin miễn phí",
	"pnBanner.pregnancy.desc": "Vui lòng điền thông tin để những gợi ý của chúng sẽ phù hợp nhất với hành trình thú vị của bạn.",
	"pnBanner.pregnancy.heading": "Bạn có đang có thai không?",
	"pnBanner.submit": "Gửi",
	"pnBanner.teenager": "Thanh thiếu niên",
	"pnBanner.teenager.heading": "Giới tính của con bạn?",
	"pnBanner.toddlers": "Trẻ tập đi",
	"pnBanner.vaccination.desc": "Giữ cho bé yếu luôn được bảo vệ với lịch tiêm chủng phù hợp với độ tuổi của bé",
	"pnBanner.vaccination.heading": "Khám phá Công cụ Lịch tiêm chủng cho trẻ ",
	"pnBanner.vaccine.btnLabel": "Lịch tiêm chủng cho trẻ ",
	"pnModal.disclaimer": "Bản tin đầu tiên đang được gửi đi, vui lòng kiểm tra hộp thư và mục spam để khám phá các nội dung dành riêng cho bạn nhé!",
	"pnTopicSection.maxSelectError.desc": "Cần bỏ ít nhất 1 chủ đề đã chọn để tiếp tục bước này",
	"pnTopicSection.maxSelectError.detail": "Hãy chọn tối đa {maxTopic} chủ đề",
	"pnTopicSection.maxSelectError.title": "Đã chọn tối đa {maxSelect} chủ đề ",
	"pnTopicSection.notFound": "Không tìm thấy thông tin bạn cần",
	"pnTopicSection.plsEnterFavTopics": "Vui lòng chọn chủ đề yêu thích",
	"pnTopicSection.ppAlsoInterested": "Mọi người cũng quan tâm",
	"pnTopicSection.recentView": "Đã xem gần đây",
	"pnTopicSection.trending": "Nổi bật",
	"popup.allTopics": "Tất cả chủ đề",
	"popup.createPost.confirmCloseDescription": "Nếu bạn đóng bây giờ, bạn sẽ mất nội dung bài đăng này",
	"popup.createPost.confirmCloseTitle": "Bạn có chắc chắn không?",
	"popup.deleteComment.description": "Việc xoá bình luận sẽ không khôi phục được",
	"popup.deleteComment.title": "Xoá bình luận?",
	"popup.deletePost.accept": "Xoá",
	"popup.deletePost.cancel": "Tắt",
	"popup.deletePost.description": "Xoá bài đăng của bạn không thể thay đổi được",
	"popup.deletePost.title": "Bạn có chắc không?",
	"popup.discardPost": "Xoá bài viết",
	"popup.discardPostEdit": "Xóa thay đổi",
	"popup.editPost": "Chỉnh sửa",
	"popup.keepEditing": "Tiếp tục chỉnh sửa",
	"popup.startANewPost": "Bắt đầu bài đăng mới",
	"post.commentCount": "{count} Bình luận",
	"post.likesCount": "{count} Thích",
	"post.remove.failed": "Xóa thất bại",
	"post.remove.success": "Đã xóa bài viết đã lưu",
	"post.save.failed": "Lưu bài viết thất bại",
	"post.save.success": "Đã lưu bài viết",
	"post.seeMore": "Xem thêm",
	"post.shareCount": "{count} Chia sẻ",
	"pregnancy.week": "Tuần",
	"pregnancyTool.description": "Em bé của bạn đang phát triển bằng <fruitName></fruitName>",
	"pregnancyTool.title": "Các tuần của Thai kỳ",
	"pregnancyTool.weightSuggested": "Cân nặng đề xuất",
	"pregnancyWeightGain.havingTwins": "Bạn có đang mang thai sinh đôi không?",
	"pregnancyWeightGain.heading": "Tăng cân trong thai kỳ",
	"pregnancyWeightGain.heightInput": "Chiều cao?",
	"pregnancyWeightGain.weekInput": "Bạn đang mang thai bao nhiêu tuần?",
	"pregnancyWeightGain.weightBeforeInput": "Cân nặng trước mang thai?",
	"pregnancyWeightGain.weightInput": "Cân nặng hiện tại?",
	"pregnancyWeightGain.weightInput.desc": "(kg)",
	"pregnancyWeightGain.weightInput.error": "Vui lòng nhập trọng lượng hợp lệ",
	"previewPhotos.title": "Bài viết của {name}",
	"profilePanel.anserwing.viewFull": "Xem câu trả lời",
	"profilePanel.awards": "Giải thưởng & Chứng nhận",
	"profilePanel.createPost": "Tạo bài đăng",
	"profilePanel.education": "Bằng cấp",
	"profilePanel.emptyCareMess.content": "Hiện tại, có vẻ như không có câu hỏi nào cho bác sĩ trong thời điểm này. Cảm ơn bạn đã trở thành một phần của cộng đồng của chúng tôi.",
	"profilePanel.emptyPostMess.content": "{name} không tham gia bất kỳ hoạt động nào gần đây.",
	"profilePanel.experience": "Kinh nghiệm",
	"profilePanel.joined": "Đã tham gia",
	"profilePanel.modal.heading": "Hồ sơ",
	"profilePanel.publishcation": "Công trình nghiên cứu, sách báo",
	"profilePanel.publishedArticles": "Bài viết được xuất bản trên Hello Bacsi",
	"profilePanel.question": "Câu hỏi",
	"profilePanel.questionNotClear": "Câu hỏi chưa rõ",
	"profilePanel.skipQuestion.content": "Chúng tôi sẽ loại bỏ câu hỏi này từ danh sách của bạn",
	"profilePanel.skipQuestion.heading": "Bỏ qua câu hỏi này",
	"profilePanel.socialLinks": "Kênh xã hội",
	"profilePanel.tabs.care": "Hỏi bác sĩ",
	"profilePanel.tabs.expertAnswer": "Bác sĩ trả lời",
	"profilePanel.tabs.highlight": "Hồ sơ bác sĩ",
	"profilePanel.tabs.posts": "Bài đăng",
	"profilePanel.tabs.relevantArticles": "Bài viết liên quan",
	"pwg.placeholder.height": "Chiều cao",
	"pwg.placeholder.weight": "Cân nặng",
	"pwgForm.week": "tuần",
	"sensitiveMask.blur": "Làm mờ",
	"sensitiveMask.contentWarningDescription": "Cảnh báo: Hình ảnh sau đây có thể gây khó chịu cho một số người xem. Bạn nên cân nhắc trước khi xem.",
	"sensitiveMask.contentWarningDescription.community": "Cảnh báo hình ảnh có thể gây khó chịu.",
	"sensitiveMask.contentWarningMessage": "Những hình ảnh sau đây có thể nhạy cảm...",
	"sensitiveMask.unblur": "Xem ảnh",
	"share.by": "Chia sẻ qua",
	"share.copyLink": "Sao chép liên kết",
	"share.letsJoinCommunity": "Tham gia cộng đồng {name}!",
	"share.letsJoinTopic": "Tham gia chủ đề {name}!",
	"share.linkCopied": "Đã sao chép link!",
	"share.linkShared": "Chia sẻ thành công",
	"share.title": "Chia sẻ",
	"shareContainer.title": "Chia sẻ kết quả",
	"similac.thankYou.done": "Hoàn tất",
	"ssov2.abTestingFlowB.description": "Đăng ký hoặc đăng nhập bằng email hoặc tài khoản mạng xã hội của bạn.",
	"ssov2.button.cancel": "Huỷ bỏ",
	"ssov2.button.continue": "Tiếp tục",
	"ssov2.button.continueGoogle": "Tiếp tục với Google",
	"ssov2.button.continueSMS": "Tiếp tục với SMS",
	"ssov2.button.continueWhatsApp": "Tiếp tục với WhatsApp",
	"ssov2.button.continueZalo": "Tiếp tục với Zalo",
	"ssov2.button.exitNow": "Thoát",
	"ssov2.button.otp.sms": "Gửi OTP qua SMS",
	"ssov2.button.otp.whatsapp": "Gửi OTP qua WhatsApp",
	"ssov2.button.otp.zalo": "Gửi OTP qua Zalo",
	"ssov2.button.save": "Lưu",
	"ssov2.button.setupLater": "Thiết lập sau",
	"ssov2.collectInfo.why": "Tại sao chúng tôi cần thông tin của bạn?",
	"ssov2.email.alreadyUsed": "Email này đã được sử dụng, vui lòng chọn Email khác.",
	"ssov2.email.button": "Tiếp tục",
	"ssov2.email.description": "Sử dụng email của bạn để tiếp tục đăng nhập hoặc đăng ký",
	"ssov2.email.title": "Tiếp tục bằng Email",
	"ssov2.error.api": "Có lỗi xảy ra",
	"ssov2.error.api.000": "Có lỗi xảy ra",
	"ssov2.error.api.001": "Vui lòng nhập chính xác email của bạn",
	"ssov2.error.api.002": "Vui lòng nhập Email",
	"ssov2.error.api.003": "Tài khoản không tồn tại",
	"ssov2.error.api.004": "Email không thể dài hơn 255 kí tự",
	"ssov2.error.api.005": "Vui lòng nhập số điện thoại",
	"ssov2.error.api.006": "Vui lòng nhập chính xác số điện thoại",
	"ssov2.error.api.007": "\bSố điện thoại đã tồn tại, vui lòng nhập số khác",
	"ssov2.error.api.008": "Vui lòng nhập mã xác thực",
	"ssov2.error.api.009": "Người dùng không được cập nhật",
	"ssov2.error.api.010": "Mã xác thực không hợp lệ",
	"ssov2.error.api.011": "Tên không hợp lệ",
	"ssov2.error.api.012": "Tên của bạn không được vượt quá 100 ký tự",
	"ssov2.error.api.013": "Tên không hợp lệ",
	"ssov2.error.api.014": "Tên của bạn đã được sử dụng",
	"ssov2.error.api.015": "Username không được vượt quá 20 ký tự",
	"ssov2.error.api.016": "Ngày sinh chưa đúng định dạng",
	"ssov2.error.api.017": " Vui lòng cập nhật Avatar",
	"ssov2.error.api.018": "Định dạng Avatar phải là hình ảnh",
	"ssov2.error.api.019": "Avatar phải thuộc định dạng: jpeg, jpg, png, gif",
	"ssov2.error.api.020": "Avatar không thể lớn hơn 10240 kb",
	"ssov2.error.api.021": "Xác nhận mật khẩu là bắt buộc",
	"ssov2.error.api.022": "Xác nhận mật khẩu phải có ít nhât 8 kí tự",
	"ssov2.error.api.023": "Xác nhận mật khẩu định dạng không hợp lệ",
	"ssov2.error.api.024": "Xác nhận mật khẩu không thế lớn hơn 50 kí tự",
	"ssov2.error.api.025": "Vui lòng nhập mật khẩu mới",
	"ssov2.error.api.026": "Mật khẩu mới cần ít nhất 8 ký tự",
	"ssov2.error.api.027": "Mật khẩu mới không hợp lệ",
	"ssov2.error.api.028": "Mật khẩu mới không hợp lệ",
	"ssov2.error.api.029": "Mật khẩu không đúng, vui lòng thử lại",
	"ssov2.error.api.030": "Mật khẩu mới không được trùng với  khẩu cũ, vui lòng thử lại",
	"ssov2.error.api.031": "Vui lòng nhập mật khẩu",
	"ssov2.error.api.032": "Vui lòng \bxác nhận mật khẩu",
	"ssov2.error.api.033": "Xác nhận mật khẩu không đúng, vui lòng thử lại",
	"ssov2.error.api.034": "Xác nhận mật khẩu mới phải có ít nhât 8 kí tự",
	"ssov2.error.api.035": "Mật khẩu mới phải có ít nhât 8 kí tự",
	"ssov2.error.api.036": "Xác nhận mật khẩu mới không thế lớn hơn 50 kí tự",
	"ssov2.error.api.037": "Mật khẩu mới không thế lớn hơn 50 kí tự",
	"ssov2.error.api.038": "Mật khẩu bạn vừa nhập không chính xác!",
	"ssov2.error.api.039": "Vui lòng nhập mật khẩu",
	"ssov2.error.api.040": "Không thể xác nhận Token Signature",
	"ssov2.error.api.041": "Token đã hết hạn",
	"ssov2.error.api.042": "Refresh Token bắt buộc",
	"ssov2.error.api.043": "Vui lòng chọn  vùng",
	"ssov2.error.api.044": "Email đã được dùng",
	"ssov2.error.api.045": "Xác nhận mã xác thực Email thất bại",
	"ssov2.error.api.046": "Trường mã code bắt buộc",
	"ssov2.error.api.047": "Số điện thoại đã được sử dụng",
	"ssov2.error.api.048": "Số điện thoại không đúng với số điện thoại bạn đã đăng kí",
	"ssov2.error.api.049": "Tài khoản đã tồn tại",
	"ssov2.error.api.050": "Trường Website id là bắt buộc",
	"ssov2.error.api.051": "Vui lòng nhập tên của bạn",
	"ssov2.error.api.052": "Vui lòng nhâp ngày sinh của bạn",
	"ssov2.error.api.053": "Vui lòng chọn giới tính của bạn",
	"ssov2.error.api.054": "Provider là bắt buộc",
	"ssov2.error.api.055": "Token là bắt buộc",
	"ssov2.error.api.056": "Mã xác thực đã được gửi đến email",
	"ssov2.error.api.057": "Email không tồn tại",
	"ssov2.error.api.058": "Bạn đang xác nhận số điện thoại của người khác",
	"ssov2.error.api.059": "Số điện thoại không hợp lệ",
	"ssov2.error.api.060": "Số  điện thoại chưa có tài khoản",
	"ssov2.error.api.061": "Số điện thoại này đã có tài khoản tại Hellobacsi. Vui lòng đăng nhập bằng số điện thoại khác",
	"ssov2.error.api.062": "ZNS bị thiếu msg_id",
	"ssov2.error.api.063": "Mã OTP không đúng",
	"ssov2.error.api.064": "Mã OTP đã hết hạn",
	"ssov2.error.api.065": "Mã xác thực không hợp lệ",
	"ssov2.error.api.066": "Lỗi khi cập nhật ZNS Tracking",
	"ssov2.error.api.067": "Gửi mã xác thực thất bại",
	"ssov2.error.api.068": "Thời gian hết hạn phải lớn hơn 10 phút",
	"ssov2.error.api.069": "Mã phải ít nhất 6 kí tự",
	"ssov2.error.api.070": "Mã không thế lớn hơn 10 kí tự",
	"ssov2.error.api.071": "Bạn đã đạt giới hạn 3 lần xác nhận trong vòng 1 giờ. Hãy thử lại sau ít phút nữa.",
	"ssov2.error.api.072": "Bạn đã đạt giới hạn 5 lần xác nhận trong 1 ngày. Hãy thử lại vào ngày mai.",
	"ssov2.error.api.073": "Mật khẩu cần ít nhất 8 ký tự",
	"ssov2.error.api.074": "Mật khẩu chưa đúng",
	"ssov2.error.api.075": "Mật khẩu xác nhận chưa đúng",
	"ssov2.error.api.076": "Mật khẩu cần chứa ít nhất 1 chữ số",
	"ssov2.error.api.077": "Mật khẩu xác nhận cần chứa ít nhất 1 chữ số",
	"ssov2.error.api.078": "Email đã được dùng",
	"ssov2.error.api.079": "Bạn đang thao tác quá nhanh. Vui lòng chờ vài giây trước khi thực hiện yêu cầu tiếp theo.",
	"ssov2.error.api.080": "Mã xác thực không hợp lệ",
	"ssov2.error.api.082": "Mật khẩu phải chứa ít nhất một chữ hoa và một chữ thường.",
	"ssov2.error.api.083": "Gửi mã WhatsApp OTP không thành công",
	"ssov2.error.facebookLogin": "Đăng nhập bằng Facebook không thành công.",
	"ssov2.error.googleLogin": "Đăng nhập bằng Google không thành công.",
	"ssov2.first.country.code": "Mã vùng",
	"ssov2.first.description": "Dùng số điện thoại, email, hoặc phương thức khác để đăng nhập hoặc đăng kí.",
	"ssov2.first.noAccountOrPass": "Bạn chưa có tài khoản hoặc chưa tạo mật khẩu, hãy tiếp tục đăng ký",
	"ssov2.first.search.country.all": "Tất cả",
	"ssov2.first.search.country.placeholder": "Chọn mã vùng",
	"ssov2.first.search.country.selected": "Mã vùng đã chọn",
	"ssov2.first.title.login": "Đăng nhập",
	"ssov2.first.title.signup": "Tạo tài khoản",
	"ssov2.orContinueWith": "Hoặc tiếp tục bằng",
	"ssov2.otp.email.description": "Chúng tôi sẽ gửi mã xác minh đến Email <b>{email}</b>. Mã xác thực sẽ hết hạn sau <b>10 phút</b>.",
	"ssov2.otp.email.title": "Xác nhận Email",
	"ssov2.otp.phone.description": "Chúng tôi sẽ gửi mã xác minh qua Số điện thoại <b>{phone}</b> bằng <b>{method}</b>. Mã xác thực sẽ hết hạn sau <b>10 phút</b>.",
	"ssov2.otp.phone.title": "Xác nhận số điện thoại",
	"ssov2.otp.resendQuestion": "Bạn chưa nhận được mã xác thực?",
	"ssov2.otp.resendText": "Gửi lại ({count}s)",
	"ssov2.otp.sendVia": "Gửi mã qua {method}",
	"ssov2.password.description": "Đăng nhập bằng mật khẩu của bạn.",
	"ssov2.password.forgotPassword": "Quên mật khẩu?",
	"ssov2.password.reset": "Lấy lại mật khẩu",
	"ssov2.password.signIn": "Đăng nhập",
	"ssov2.password.title1": "Chào mừng!",
	"ssov2.password.title2": "Nhập mật khẩu",
	"ssov2.passwordForgotSetup.description": "Tạo mật khẩu để đăng nhập và hoàn tất đăng kí tài khoản tại Hellobacsi",
	"ssov2.passwordForgotSetup.field.password.atLeast8Chars": "Có ít nhất 8 kí tự",
	"ssov2.passwordForgotSetup.field.password.atLeastOneUpper": "Có ít nhất 1 chữ viết hoa, 1 chữ viết thường, và 1 chữ số",
	"ssov2.passwordForgotSetup.field.password.label": "Mật khẩu",
	"ssov2.passwordForgotSetup.field.password.placeholder": "Nhập mật khẩu",
	"ssov2.passwordForgotSetup.field.passwordConfirm.label": "Xác nhận mật khẩu",
	"ssov2.passwordForgotSetup.field.passwordConfirm.placeholder": "Xác nhận mật khẩu",
	"ssov2.passwordForgotSetup.title": "Tạo mật khẩu",
	"ssov2.phone.alreadyUsed": "Số điện thoại này đã được sử dụng, vui lòng chọn Số điện thoại khác.",
	"ssov2.phoneVerify.description": "Vui lòng cung cấp thêm thông tin để hoàn tất quá trình đăng ký tài khoản.",
	"ssov2.phoneVerify.title": "Xác nhận số điện thoại",
	"ssov2.policyText": "Bằng cách đăng ký, tôi xác nhận rằng mình đã đọc, hiểu và đồng ý với {privacy} và {terms} của Hellobacsi. Tôi đồng ý để Hellobacsi thu thập, lưu trữ, sử dụng, tiết lộ và xử lý thông tin của tôi theo Chính sách quyền riêng tư của Hellobacsi. Ngoài ra, tôi đồng ý cho Hello Health Group sử dụng thông tin của tôi và gửi cho tôi thông tin quảng cáo (bao gồm qua thư trực tiếp, email, điện thoại và tin nhắn văn bản) hoặc liên hệ với tôi để giới thiệu các sản phẩm, dịch vụ, chương trình hoặc các chủ đề khác mà Hello Health Group cho rằng tôi có thể quan tâm; và Hello Health Group có thể chia sẻ thông tin của tôi với các đối tác và khách hàng để họ cung cấp các dịch vụ và thông tin quảng cáo hữu ích hơn.",
	"ssov2.policyText.community": "Bằng cách đăng ký, tôi xác nhận rằng mình đã đọc, hiểu và đồng ý với {privacy} và {terms} của Hellobacsi. Tôi đồng ý tham gia cộng đồng của Hello Bacsi và tôi đồng ý để Hellobacsi thu thập, lưu trữ, sử dụng, tiết lộ và xử lý thông tin của tôi theo Chính sách quyền riêng tư của Hellobacsi. Ngoài ra, tôi đồng ý cho Hello Health Group sử dụng thông tin của tôi và gửi cho tôi thông tin quảng cáo (bao gồm qua thư trực tiếp, email, điện thoại và tin nhắn văn bản) hoặc liên hệ với tôi để giới thiệu các sản phẩm, dịch vụ, chương trình hoặc các chủ đề khác mà Hello Health Group cho rằng tôi có thể quan tâm; và Hello Health Group có thể chia sẻ thông tin của tôi với các đối tác và khách hàng để họ cung cấp các dịch vụ và thông tin quảng cáo hữu ích hơn.",
	"ssov2.policyText.privacy": "Chính sách bảo mật",
	"ssov2.policyText.terms": "Điều khoản sử dụng",
	"ssov2.popup.close.description": "Chỉ còn một bước nữa là hoàn tất việc thiết lập tài khoản của mình. Bạn có thực sự muốn thoát?",
	"ssov2.popup.close.title": "Bạn có chắc muốn thoát?",
	"ssov2.resetPassword.description": "Vui lòng cung cấp số điện thoại bạn đã sử dụng để tạo tài khoản.",
	"ssov2.resetPassword.title": "Quên mật khẩu?",
	"ssov2.setup.button.createAccount": "Tạo tài khoản mới",
	"ssov2.setup.button.veriyPhone": "Xác nhận số điện thoại",
	"ssov2.setup.description": "Vui lòng cung cấp thêm thông tin để hoàn tất quá trình đăng ký tài khoản.",
	"ssov2.setup.field.dob.label": "Ngày sinh",
	"ssov2.setup.field.dob.placeholder": "Nhập ngày sinh của bạn",
	"ssov2.setup.field.email.label": "Email",
	"ssov2.setup.field.gender.female": "Nữ",
	"ssov2.setup.field.gender.label": "Giới tính",
	"ssov2.setup.field.gender.male": "Nam",
	"ssov2.setup.field.name.label": "Tên",
	"ssov2.setup.field.name.placeholder": "Nhập tên của bạn",
	"ssov2.setup.field.otp.label": "Nhận OTP qua",
	"ssov2.setup.field.phone.label": "Số điện thoại",
	"ssov2.setup.title": "Sắp hoàn tất rồi",
	"ssov2.updateEmail.button": "Xác nhận email",
	"ssov2.updateEmail.description": "Vui lòng cập nhật và xác minh Email của bạn để tiếp tục.",
	"ssov2.updateEmail.title": "Cập nhật Email",
	"ssov2.useOtherMethod.email": "Tài khoản này chưa kích hoạt đăng nhập bằng email. Vui lòng chọn phương thức đăng nhập khác.",
	"ssov2.useOtherMethod.phone": "Tài khoản này chưa kích hoạt đăng nhập bằng số điện thoại. Vui lòng chọn phương thức đăng nhập khác.",
	"ssov2.validate.confirmPassword.match": "Mật khẩu phải trùng nhau",
	"ssov2.validate.confirmPassword.required": "Mật khẩu lặp lại bắt buộc",
	"ssov2.validate.dob.required": "Ngày sinh bắt buộc",
	"ssov2.validate.email.invalid": "Email không hợp lệ",
	"ssov2.validate.email.required": "Email bắt buộc",
	"ssov2.validate.gender.oneOf": "Vui lòng chọn giới tính của bạn",
	"ssov2.validate.gender.required": "Giới tính bắt buộc",
	"ssov2.validate.name.required": "Tên bắt buộc",
	"ssov2.validate.otp.required": "Phương thức OTP bắt buộc",
	"ssov2.validate.password.required": "Mật khẩu bắt buộc",
	"ssov2.validate.phone.required": "Số điện thoại bắt buộc",
	submit: submit,
	"switchBtn.no": "Không",
	"switchBtn.yes": "Có",
	"tab.about": "Về chúng tôi",
	"tab.discussion": "Thảo luận",
	"tab.topic": "Chủ đề",
	"tagTopic.moreTopics": "{number} chủ đề khác",
	"targetHearRate.heading": "Công cụ tính nhịp tim lý tưởng",
	"targetHeartRate.aerobicZone.note": "Aerobic Zone (tập thể dục / thể thao vừa phải 3-5 ngày / tuần)",
	"targetHeartRate.aerobicZone.title": "Aerobic Zone",
	"targetHeartRate.ageInput": "Hãy điền ngày tháng năm sinh của bạn",
	"targetHeartRate.ageInput.desc": "(năm)",
	"targetHeartRate.ageInput.error": "Vui lòng nhập độ tuổi chính xác của bạn",
	"targetHeartRate.heartRateInput": "Nhịp tim nghỉ ngơi của bạn là bao nhiêu?",
	"targetHeartRate.heartRateInput.desc": "(bpm)",
	"targetHeartRate.heartRateInput.error": "Vui lòng nhập nhịp tim nghỉ ngơi chính xác của bạn",
	"targetHeartRate.lowIntensity.note": "Cường độ thấp (ít hoặc không tập thể dục)",
	"targetHeartRate.lowIntensity.title": "Cường độ thấp",
	"targetHeartRate.maximumIntensity.note": "Cường độ tối đa (tập thể dục / thể thao rất chăm chỉ hoặc tập luyện gấp đôi)",
	"targetHeartRate.maximumIntensity.title": "Cường độ tối đa",
	"targetHeartRate.moderateIntensity.note": "Cường độ vừa phải (tập thể dục / thể thao 1-3 ngày / tuần)",
	"targetHeartRate.moderateIntensity.title": "Cường độ vừa phải",
	"targetHeartRate.optional": "(Tùy chọn khác)",
	"targetHeartRate.selectActive": "Bạn đang hoạt động như thế nào hằng ngày?",
	"targetHeartRate.vigorousIntensity.note": "Cường độ mạnh (tập thể dục / thể thao chăm chỉ 6-7 ngày / tuần)",
	"targetHeartRate.vigorousIntensity.title": "Cường độ mạnh",
	"tool.askChecking": "Tôi đang kiểm tra cho người khác",
	"tool.selectPerson": "Bạn đang kiểm tra cho",
	"tool.selectPerson.other": "Người khác",
	"tool.selectPerson.yourSelf": "Bản thân",
	"toolPage.toolReviewer": "Tham vấn y khoa: {expert_name} ngày {date}",
	"tools.checkYourKidsInput.label": "Bạn làm  kiểm tra cho con bạn?",
	"tools.checkYrs": "Bạn đang tính chỉ số cho chính mình?",
	"tools.heading.on": "ngày",
	"tools.heartRateRangeErr": "Vui lòng nhập giá trị trong khoảng {min} - {max} bmp",
	"tools.inputPlaceholder": "Ví dụ: {content}",
	"tools.requiredErrorMess.age": "Vui lòng nhập số tuổi chính xác",
	"tools.requiredErrorMess.gender": "Vui lòng chọn giới tính",
	"tools.selectBabyGender": "Giới tính của trẻ là gì?",
	"tools.selectGender": "Giới tính của bạn",
	"tools.yearsOld": "tuổi",
	"updatePost.popup.success": "Cập nhật bài đăng thành công",
	"userProfile.nav.card.eCom": "Cửa hàng",
	"userProfile.nav.card.ecom.DeliveryAddress": "Địa chỉ giao hàng",
	"userProfile.nav.card.ecom.manageOrders": "Quản lý đơn hàng",
	"userProfile.nav.card.ecom.voucher": "Khuyến mãi",
	"userProfile.nav.card.myBooking": "Lịch sử đặt chỗ",
	"userProfile.nav.card.myCommunity": "Đã tham gia",
	"userProfile.nav.card.myFamily": "Hồ sơ gia đình",
	"userProfile.nav.card.myHealth": "Sức khỏe",
	"userProfile.nav.card.mySaved": "Đã lưu",
	"userProfile.nav.header.count.comments": "Bình luận",
	"userProfile.nav.header.count.posts": "Bài đăng",
	"userProfile.nav.header.count.tools": "Công cụ",
	"userProfile.nav.header.points": "Điểm",
	"userProfile.nav.header.viewProfile": "Xem hồ sơ của tôi",
	"userProfile.nav.menu.accountSettings": "Thiết lập tài khoản",
	"userProfile.nav.menu.dataPrivacy": "Quyền riêng tư dữ liệu",
	"userProfile.nav.menu.disableAccount": "Vô hiệu hoá tài khoản",
	"userProfile.nav.menu.help": "Trợ giúp",
	"userProfile.nav.menu.logout": "Đăng xuất",
	"userProfile.nav.menu.password": "Mật khẩu",
	"userProfile.userRank.ambassador": "Đại sứ",
	"userProfile.userRank.doctor": "Bác sĩ",
	"userProfile.userRank.expert": "Chuyên gia",
	"userProfile.userRank.influencer": "Người ảnh hưởng",
	"userProfile.userRank.member": "Thành viên",
	"validation.error.requiredAgeGroup": "Your child is not in the required age group",
	"validation.error.requiredField": "Vui lòng điền mục này",
	"verifyBotAnswer.confirmEndorse.accept": "Chứng nhận",
	"verifyBotAnswer.confirmEndorse.cancel": "Hủy",
	"verifyBotAnswer.confirmEndorse.description": "Cảm ơn bạn đã chứng nhận câu trả lời của cộng đồng chúng tôi!",
	"verifyBotAnswer.confirmEndorse.heading": "Chứng nhận câu trả lời!",
	"footer.followUsText": "Follow us",
	"footer.info.address": "Địa chỉ: Tầng 5, Tòa nhà Sonatus, 15 Lê Thánh Tôn, P.Bến Nghé, Quận 1, Thành phố Hồ Chí Minh",
	"footer.info.certificate": "Giấy xác nhận cung cấp dịch vụ mạng xã hội trực tuyến số 592/GP-BTTTT HN ngày 03/12/2019",
	"footer.info.companyName": "Công ty TNHH Xin Chào Bác Sĩ",
	"footer.info.contentResponsibility": "Chịu trách nhiệm quản lý nội dung: Hoàng Diệu Thu",
	"footer.info.email": "Email: advertiser@hellohealthgroup.com",
	"footer.info.license": "Giấy phép kinh doanh số: 0315857817 do Sở kế hoạch và Đầu tư TP. Hồ Chí Minh cấp ngày 21-8-2019",
	"searchPage.result": "Có <span>{result}</span> kết quả"
};

export { character, copied, copy, mbTranslations as default, insert, loading, orCopyLink, submit };
